import Table from 'react-bootstrap/Table';
import {useTranslation} from "react-i18next";
import PlayerNameWithFlag from "../PlayerNameWithFlag";
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {getLoggedUser} from "../../../util/SecurityUtils";
import type {Player} from "../../../types/domain";

interface PlayerSeedingTableProps {
  players: Player[];
  isEditable?: boolean;
}

function PlayerSeedingTable(props: PlayerSeedingTableProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleOnClick = useCallback((id: number) => navigate('/players/' + id), [navigate]);
    return (
        <Table striped bordered hover size="sm" variant="dark">
            <thead style={{"textTransform": "none"}}>
            <tr>
              <th className="text-center" style={{width: "3rem"}}>#</th>
              <th>{t("player")}</th>
            </tr>
            </thead>
            <tbody>
            {props.players.map((player, index) => {
                const isLoggedUser = getLoggedUser()?.playerId === player.id;
                const highlightClass = isLoggedUser ? " highlighted-score-top highlighted-score-bottom" : "";
                return (
                    <tr key={player.id} onClick={() => handleOnClick(player.id)} className={"clickable" + highlightClass}>
                      <th className="text-center">{index + 1}.</th>
                      <th><PlayerNameWithFlag player={player} includeElo={true} aliasOnly={true} /></th>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    );
}

export default PlayerSeedingTable
